<template lang="pug">
.other-office-connection-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- セル：登録状況
    template(#cell(status)="row")
      span(:class="getStatusLabelClass(row.item)") {{ convertStatus(row.item) }}
    //- セル：招待
    template(#cell(isSender)="row")
      span {{ convertIsSender(row.item) }}
    //- セル：最終招待送信日時
    template(#cell(latestSendDatetime)="row")
      span {{ convertDatetime(row.item.latestSendDatetime) }}
    //- セル：登録情報
    template(#cell(operation)="row")
      button.btn.edit-btn.mr-2(@click="onEdit(row.item)") 修正
      button.btn.delete-btn(@click="onDelete(row.item)") 削除
      button.btn.resend-btn.ml-2(v-if="showResend(row.item)" @click="onResend(row.item)") 招待再送
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeConnectionGetModel } from "@/commons/services/OtherOfficeConnections";

/**
 * ### 他事業所連携テーブルコンポーネント
 */
@Component({})
export default class OtherOfficeConnectionTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherOfficeConnectionTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherOfficeConnectionTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<OtherOfficeConnectionTableItem> {
    return this.value;
  }

  public getStatusLabelClass(item: OtherOfficeConnectionTableItem): Object {
    if (item.registerd == true) {
      return {
        registerd: true
      };
    } else {
      return {
        invitation: true
      };
    }
  }

  public convertStatus(item: OtherOfficeConnectionTableItem): string {
    if (item.registerd == true) {
      return "登録済";
    } else {
      return "招待中";
    }
  }

  public convertIsSender(item: OtherOfficeConnectionTableItem): string {
    if (item.isSender == true) {
      return "招待";
    } else {
      return "被招待";
    }
  }

  public convertDatetime(datetime: number): string {
    if (datetime) {
      return this.$dateUtil.convertNumberToString(datetime, "yyyy/mm/dd hh:MM");
    } else {
      return "";
    }
  }

  /**
   * ### フィルタリング
   */
  public filterTable(item: OtherOfficeConnectionTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(item, filter);
  }

  public filterSearchWords(item: OtherOfficeConnectionTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundOfficeName: boolean = true;
    let foundStaffName: boolean = true;

    for (const word of words) {
      if (item.officeName.indexOf(word) == -1) {
        foundOfficeName = false;
      }
      if (item.staffName.indexOf(word) == -1) {
        foundStaffName = false;
      }
    }

    return foundOfficeName || foundStaffName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: OtherOfficeConnectionTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: OtherOfficeConnectionTableItem): void {
    this.$emit("onDelete", item);
    return;
  }

  /**
   * ### 招待再送ボタン押下イベント
   */
  public onResend(item: OtherOfficeConnectionTableItem): void {
    this.$emit("onResend", item);
    return;
  }

  public showResend(item: OtherOfficeConnectionTableItem): boolean {
    return item.registerd ? false : true;
  }
}

/** テーブルの列名の情報 */
export interface OtherOfficeConnectionTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OtherOfficeConnectionTableItem extends OtherOfficeConnectionGetModel {}

export interface FilterSetting {
  /** 検索ワード */
  searchWord: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.other-office-connection-table-component {
  .registerd,
  .invitation {
    font-weight: bold;
  }
  .registerd {
    color: $font-key-color;
  }
  .invitation {
    color: $font-strong-color;
  }
  .edit-btn,
  .delete-btn,
  .resend-btn {
    width: 94px;
  }
}
</style>
